import { Component, OnInit, Input, ViewChild, SimpleChanges, OnChanges } from '@angular/core';

// declare var google: any;
import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexStroke,
  ApexTitleSubtitle,
  ApexDataLabels,
  ApexGrid,
  ApexYAxis,
  ApexFill,
  ApexMarkers // <-- Import ApexMarkers
} from "ng-apexcharts";
export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  stroke: ApexStroke;
  title: ApexTitleSubtitle;
  dataLabels: ApexDataLabels;
  grid: ApexGrid;
  yaxis: ApexYAxis;
  fill: ApexFill;
  colors?: string[]; // Added to support colors property
  markers?: ApexMarkers; // <-- Add markers property
};

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.css']
})
export class LineChartComponent implements OnInit, OnChanges {

  @Input() chartData: any;
  @Input() chartName: any;
  @Input() chartTitleName: any;

  @ViewChild("chart") chart!: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  selectedFilter = 'weekly';

  // yearlyData = {
  //   data: [0, 0, 0, 20, 330],
  //   categories: ["2021", "2022", "2023", "2024", "2025"]
  // };  // Example data for 2021-2025
  // monthlyData = {
  //   data: [10, 30, 45, 60, 90, 120, 150, 180, 200, 250, 300, 330],
  //   categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  // }; // Example
  // weeklyData = {
  //   data: [5, 10, 15, 25, 40, 70, 100, 150],
  //   categories: ["W1", "W2", "W3", "W4", "W5", "W6", "W7", "W8"]
  // }; // Example

  constructor() {

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["chartData"] && this.chartData) {
      // Add a small delay to ensure the container dimensions are stable
      setTimeout(() => {
        this.chartOptions = {
          series: [
            {
              name: this.chartTitleName,
              data: this.chartData.weekly?.data
            }
          ],
          chart: {
            type: "area",
            height: 350,
            toolbar: {
              show: false
            }
          },
          stroke: {
            curve: "smooth",
            width: 3,
            colors: ["#28a745"] // Green line
          },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.8,
              opacityTo: 0.1,
              stops: [0, 90, 100],
            } as any
          },
          dataLabels: {
            enabled: false // hide numbers
          },
          markers: {
            size: 4,
            colors: ["#28a745"],
            strokeColors: "#fff",
            strokeWidth: 2,
            hover: {
              size: 6
            }
          },
          xaxis: {
            categories: this.chartData.weekly?.categories
          },
          yaxis: {
            title: {
              text: this.chartName
            }
          }
        };
        this.onFilterChange();
      }, 100); // 100ms delay
    }
  }
  ngOnInit(): void {
  }

  onFilterChange() {
    if (this.selectedFilter === "yearly") {
      this.chartOptions.series = [{ name: this.chartTitleName, data: this.chartData?.yearly?.data }];
      this.chartOptions.xaxis = { categories: this.chartData?.yearly?.categories };
    } else if (this.selectedFilter === "monthly") {
      this.chartOptions.series = [{ name: this.chartTitleName, data: this.chartData?.monthly?.data }];
      this.chartOptions.xaxis = { categories: this.chartData?.monthly?.categories };
    } else if (this.selectedFilter === "weekly") {
      this.chartOptions.series = [{ name: this.chartTitleName, data: this.chartData?.weekly?.data }];
      this.chartOptions.xaxis = { categories: this.chartData?.weekly?.categories };
    }
  }
  resetZoom() {
    this.chart.resetSeries(); // this resets zoom to original state
  }
}